export default __webpack_public_path__ + "static/media/property_937.32a9fef4.png";